

import heroThiago from "../../../assets/images/hero-thiago.png";


export default function Hero() {
  return (
<section className="relative w-full min-h-screen flex items-end md:items-end overflow-hidden bg-neutral-950">
  {/* Imagem de fundo */}
  <div className="absolute inset-0 z-0">
    <img
      src={heroThiago}
      alt="Thiago Vieira - Personal Trainer"
      className="w-full h-full object-cover object-[center_60%] md:object-[125%_15%]"
    />
    {/* Overlay: escurece a base para o texto ler bem */}
    <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/70 to-neutral-950/20" />
  </div>

  {/* Conteúdo — ancorado embaixo */}
  <div className="relative z-10 w-full max-w-6xl mx-auto px-6 pb-16 md:pb-24 md:max-w-7xl flex justify-between">
    <div className="max-w-xl flex flex-col gap-6 md:max-w-6xl md:flex-row">
<div>      <h1 className="font-display text-4xl sm:text-5xl md:text-7xl text-neutral-50 leading-tight">
        TRANSFORME SEU CORPO.
        <br />
        <span className="text-gold-500">TRANSFORME SUA VIDA.</span>
      </h1>

      <h4 className="pb-2 text-base md:text-lg text-neutral-300 leading-relaxed max-w-md">
        Você não nasceu para se sentir mal com o próprio corpo.
        Eu te ajudo a esculpir o físico que você sempre quis.
      </h4>
</div>
      <div className="flex flex-col gap-4 w-full max-w-md justify-end">
        <a                 href="https://wa.me/5548999145340?text=Olá! Gostaria de agendar uma Avaliação." className="flex items-center justify-center gap-2 w-full bg-gold-500 hover:bg-gold-400 text-neutral-950 font-semibold py-4 px-6 rounded-lg transition-colors uppercase tracking-wide text-sm">
          Agendar Avaliação
          <svg xmlns="[w3.org](http://www.w3.org/2000/svg)" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </a>

        <a
                href="https://wa.me/5548999145340?text=Olá! Gostaria de saber mais sobre os seus serviços."
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full border border-neutral-700 hover:border-neutral-500 bg-neutral-900/60 text-neutral-100 font-semibold py-4 px-6 rounded-lg transition-colors uppercase tracking-wide text-sm"
        >
          <svg xmlns="[w3.org](http://www.w3.org/2000/svg)" width="18" height="18" viewBox="0 0 24 24" fill="#25D366">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
          Falar no WhatsApp
        </a>
      </div>
    </div>
  </div>
</section>

  );
}
